import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { List, Spin } from 'antd';
import cn from 'classnames';

const InfinitiveList = ({
  infinitiveProps,
  renderItem,
  loaderRef,
  className,
  hasMore = true,
  dataSource = [],
  ...listProps
}) => {
  return (
    <div className={className} style={{ height: '100%' }}>
      <InfiniteScroll
        dataLength={(dataSource || []).length}
        next={() => {
          throw new Error('Function not implemented.');
        }}
        hasMore={hasMore}
        loader={
          <div ref={loaderRef} style={{ width: '100%', textAlign: 'center' }}>
            <Spin spinning tip="Loading More Data" />
          </div>
        }
        {...infinitiveProps}>
        <List dataSource={dataSource} renderItem={renderItem} {...listProps} />
      </InfiniteScroll>
    </div>
  );
};

export default InfinitiveList;
